import { Icon, IconProps } from '@chakra-ui/react';
// TODO: Temporary usage of react-icons
// Gamma team to have OS icons provided in the design system
import {
  FaLinux,
  FaWindows,
  FaApple,
  FaAndroid,
  FaDesktop,
} from 'react-icons/fa';

/** OS type identifiers */
export enum OSType {
  Linux = 'linux',
  Windows = 'windows',
  MacOS = 'macos',
  Android = 'android',
  Unknown = 'unknown',
}

/** Linux distribution identifiers for OS detection */
enum LinuxIds {
  Linux = 'linux',
  Ubuntu = 'ubuntu',
  Debian = 'debian',
  CentOS = 'centos',
  RedHat = 'redhat',
  Fedora = 'fedora',
}

/** macOS/Apple identifiers for OS detection */
enum MacOSIds {
  Mac = 'mac',
  Darwin = 'darwin',
  iOS = 'ios',
}

/** Windows identifiers for OS detection */
enum WindowsIds {
  Windows = 'windows',
  Win = 'win',
}

/** Android identifiers for OS detection */
enum AndroidIds {
  Android = 'android',
}

/**
 * Determines which OS type based on the OS string
 */
export const getOSType = (os: string | undefined): OSType => {
  if (!os) return OSType.Unknown;
  const type = os.toLowerCase();
  const isLinux = Object.values(LinuxIds).some((os) => type.includes(os));
  if (isLinux) return OSType.Linux;
  const isMacOS = Object.values(MacOSIds).some((os) => type.includes(os));
  if (isMacOS) return OSType.MacOS;
  const isWindows = Object.values(WindowsIds).some((os) => type.includes(os));
  if (isWindows) return OSType.Windows;
  const isAndroid = Object.values(AndroidIds).some((os) => type.includes(os));
  if (isAndroid) return OSType.Android;
  return OSType.Unknown;
};

export interface OSIconProps extends Omit<IconProps, 'as'> {
  /** Operating system string to determine which icon to display */
  os?: string;
}

/** Maps OS types to their corresponding react-icons */
const OS_ICON_MAP = {
  [OSType.Linux]: FaLinux,
  [OSType.Windows]: FaWindows,
  [OSType.MacOS]: FaApple,
  [OSType.Android]: FaAndroid,
  [OSType.Unknown]: FaDesktop,
} as const;

/**
 * Displays an appropriate OS icon based on the operating system string.
 * Supports Linux, Windows, macOS, Android, and falls back to a generic desktop icon.
 *
 * @note Temporary implementation using react-icons. Gamma team
 * to potentially have OS icons provided in the design system in the near future.
 */
export const OSIcon = ({ os, ...props }: OSIconProps): JSX.Element => {
  const osType = getOSType(os);
  const IconComponent = OS_ICON_MAP[osType];

  return <Icon as={IconComponent} {...props} />;
};
